import { useState } from 'react'
import Header from '../Header'
import Pagination from '../Pagination'
import { Div, ErrorCard, Spinner } from '../..'
import {
  TableGridStyled,
  ErrorContainer,
} from './styles'


const Grid = ({
  headers = [],
  currentPage = 0,
  totalResults,
  resultsPerPage,
  onChangePage,
  error,
  children,
  isLoading
}) => {

  const [isInnerScrolling, setIsInnerScrolling] = useState(false)

  const totalPages = Math.ceil(totalResults / resultsPerPage)

  const handleInnerScroll = () => {
    setIsInnerScrolling(true)
    setTimeout(() => {
      setIsInnerScrolling(false)
    }, 300);
  }

  const childrenElements = typeof children === 'function'
    ? children({ isInnerScrolling })
    : children


  if (isLoading) {
    return (
      <ErrorContainer>
        <Div color='#7F39FA'>
          <Spinner size={50}/>
        </Div>
      </ErrorContainer>
    )
  }


  if (error) {
    return (
      <ErrorContainer>
        <ErrorCard
          icon={error.icon}
          title={error.title}
          description={error.description}
        />
      </ErrorContainer>
    )
  }


  return (
    <>
      <TableGridStyled onScroll={handleInnerScroll}>
        {headers.map((head, idx) => (
          <Header
            key={idx}
            tooltip={head.tooltip}
            isOrdered={head.isOrdered}
            order={head.order}
            onClick={head.onClick}
          >
            {head.label?.toUpperCase()}
          </Header>
        ))}

        { childrenElements }

      </TableGridStyled>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onChange={onChangePage}
        />
      )}
    </>
  )
}

export default Grid